import { Component, OnInit } from '@angular/core';
import { IFloatingFilterParams } from 'ag-grid-community';
import { AgFloatingFilterComponent } from 'ag-grid-angular';
import { IntegrationService } from '../../../../shared/services/integration.service';
import { FormsModule } from '@angular/forms';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';
import { MatSelect, MatOption } from '@angular/material/select';

@Component({
    selector: 'day-to-execute-filter-component',
    templateUrl: './day-to-execute-filter.component.html',
    styleUrls: ['./day-to-execute-filter.component.scss'],
    standalone: true,
    imports: [FormsModule, CdkOverlayOrigin, NgClass, CdkConnectedOverlay, MatSelect, MatOption]
})
export class DayToExecuteFilterComponent implements OnInit, AgFloatingFilterComponent {
  params: IFloatingFilterParams;
  currentValue: number | null | string = null;
  selectedValue: number | null | string = null;
  isOpen: boolean;
  dayFrom: number;
  dayTo: number;
  daytoExecuteWeekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
  public deleteIcon: string;

  constructor(private integrationService: IntegrationService) {}

  ngOnInit(): void {
    const assetUrl = this.integrationService.getApplicationPath();
    this.deleteIcon = assetUrl + 'assets/images/Delete.svg';
  }

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
  }

  openMenu(): void {
    this.isOpen = !this.isOpen;
    if (this.currentValue) {
      this.selectedValue = this.currentValue;
    }
  }

  toggleDayToExecute(value: boolean): void {
    this.isOpen = value;
  }

  onParentModelChanged(parentModel: any): void {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      this.currentValue = null;
    } else {
      this.currentValue = parentModel.filter;
    }
  }

  dayFrequencyInputChanged(): void {
    if (this.dayFrom > 0 || this.dayTo > 0) {
      this.selectedValue = null;
    }
  }

  onDayToExcecuteSelected(): void {
    this.dayFrom = null;
    this.dayTo = null;
  }

  applyDayToExecute(): void {
    if (!this.selectedValue && !this.dayFrom && !this.dayTo) {
      // Remove the filter
      this.params.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged(null, null);
      });
      this.isOpen = false;
      return;
    }
    if (this.selectedValue) {
      this.currentValue = this.selectedValue;
      this.params.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged('equals', this.currentValue);
      });
    } else {
      if (!this.dayFrom) {
        this.dayFrom = 1;
      }
      this.currentValue = this.dayFrom;
      if (!this.dayTo) {
        this.dayTo = 31;
      }
      this.currentValue = this.currentValue + '-' + this.dayTo;
      this.params.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged('equals', this.currentValue);
      });
    }
    this.isOpen = false;
  }

  clearDayToExecute(event): void {
    event.preventDefault();
    this.dayFrom = null;
    this.dayTo = null;
    this.selectedValue = null;
    this.currentValue = null;
    const colID = this.params.column.getColId();
    this.params.api.setColumnFilterModel(colID, null);
    this.params.api.onFilterChanged();
  }
}
